import { ErrorReportPage } from "./ErrorReportPage";
export default ErrorReportPage;
